export const featuresPerks = {
  Dragon: {
    3: 'All friendly dragons have 100 mana when battle starts.',
  },
  Elf: {
    3: 'Evasion increased by 25% for all friendly elfs.',
    6: 'Evasion increased by 25% for all friendly elfs.',
  },
  Undead: {
    2: 'Armor decreased by 5 for all enemies.',
    4: 'Armor decreased by 7 for all enemies.',
  },
  Orc: {
    2: 'Max HP increased by 250 for all friendly orcs.',
    4: 'Max HP increased by 350 for all friendly orcs.',
  },
  Goblin: {
    3: 'Armor and hp regeneration increased by 15 for a random ally.',
    6: 'Armor and hp regeneration increased by 15 for all friendly goblins.',
  },
  Element: {
    2: 'All friendly elements have 30% chance to turn attacker into stone for 3s when attacked by melee chesses.',
    4: 'All allies have 30% chance to turn attacker into stone for 3s when attacked by melee chesses.',
  },
  Human: {
    2: 'All friendly humans have 20% chance to disarm target for 3s on damage deal.',
    4: 'All friendly humans have 25% chance to disarm target for 3s on damage deal.',
    6: 'All friendly humans have 30% chance to disarm target for 3s on damage deal.',
  },
  Naga: {
    2: 'Magic resistance increased by 20 for all allies.',
    4: 'Magic resistance increased by 40 for all allies.',
  },
  Troll: {
    2: 'Attack speed increased by 30 for all friendly trolls.',
    4: 'Attack speed increased by 30 for all allies.',
  },
  Beast: {
    2: 'Attack damage increased by 10% for all allies.',
    4: 'Attack damage increased by 15% for all allies.',
    6: 'Attack damage increased by 20% for all allies.',
  },
  Assassin: {
    3: 'All friendly assasins have 10% chance to deal 3.5x damage.',
    6: 'All friendly assasins have 20% chance to deal 4.5x damage.',
  },
  Druid: {
    2: 'two ★druids can upgrade to a ★★druid.',
    4: 'two ★★druids can upgrade to a ★★★druid.',
  },
  Hunter: {
    3: 'Attack damage increased by 25% for all friendly hunters.',
    6: 'Attack damage increased by 35% for all friendly hunters.',
  },
  Knight: {
    2: 'All friendly knights +25% chance to get a shield.',
    4: 'All friendly knights +35% chance to get a shield.',
    6: 'All friendly knights +45% chance to get a shield.',
  },
  Mage: {
    3: 'Magic resistance decreased by 40% for all enemies.',
    6: 'Magic resistance decreased by an additional 40% for all enemies.',
  },
  Mech: {
    2: 'HP regeneration increased by 15 for all friendly mechs.',
    4: 'HP regeneration increased by 25 for all friendly mechs.',
  },
  Shaman: {
    2: 'Hex an enemy when battle starts.',
  },
  Warlock: {
    3: 'Lifesteal increased by 20% for all allies.',
    6: 'Lifesteal increased by 30% for all allies.',
  },
  Warrior: {
    3: 'Armor increased by 7 for all friendly warriors.',
    6: 'Armor increased by an additional 8 for all friendly warriors.',
    9: 'Armor increased by an additional 9 for all friendly warriors.',
  },
};



// WEBPACK FOOTER //
// ./src/featuresPerks.tsx